// src/components/Curriculum/CurriculumForm.tsx
import React, { useState } from 'react';
import { TextField, Button, Container, Box } from '@mui/material';

const CurriculumForm: React.FC<{ initialData?: { name: string; description: string; startDate: string; endDate: string; }, onSubmit: (data: { name: string; description: string; startDate: string; endDate: string; }) => void }> = ({ initialData, onSubmit }) => {
  const [formData, setFormData] = useState(initialData || { name: '', description: '', startDate: '', endDate: '' });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Container maxWidth="sm">
      <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          label="Nimi"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          fullWidth
        />
        <TextField
          label="Kuvaus"
          name="description"
          value={formData.description}
          onChange={handleChange}
          required
          multiline
          rows={4}
          fullWidth
        />
        <TextField
          label="Aloituspäivä"
          type="date"
          name="startDate"
          value={formData.startDate}
          onChange={handleChange}
          required
          InputLabelProps={{ shrink: true }}
          fullWidth
        />
        <TextField
          label="Lopetuspäivä"
          type="date"
          name="endDate"
          value={formData.endDate}
          onChange={handleChange}
          required
          InputLabelProps={{ shrink: true }}
          fullWidth
        />
        <Button variant="contained" color="primary" type="submit">
          Save
        </Button>
      </Box>
    </Container>
  );
};

export default CurriculumForm;
